module.exports = "/build/images/trash-alt.svg?b8669cdbbfdde4a9d1495b2e98f17b77";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/trash-alt.svg
// module id = 4502
// module chunks = 0